export enum MagicLinkType {
  ManageScheduleScreen = 'manageScheduleScreen',
  BookDragKingsApplicationScreen = 'bookDragKingsApplicationScreen',
}

export interface SendConversationMagicLinkPayload {
  type: MagicLinkType;
}
